

export interface CustomEventParams {
  bubbles: boolean;
  cancelable: boolean;
  detail?: any;
}

/**
 * Dispatch a synthetic event
 * @param element the DOM element
 * @param eventName the name of the event to dispatch
 * @param params { bubbles: false, cancelable: false, detail: {id: 1234}}
 */
export function dispatchCustomEvent(element: HTMLElement, eventName: string, params: CustomEventParams = { bubbles: true, cancelable: true, detail: undefined }) {
  let customEvent: any;
  if (typeof (CustomEvent) === 'function') {
    customEvent = new CustomEvent(eventName, params);
    customEvent = element.dispatchEvent(customEvent);
  } else {
    customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
    customEvent = element.dispatchEvent(customEvent);
  }
  return customEvent;
}


// WEBPACK FOOTER //
// ./src/helpers/custom-event.ts